import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'

export class PosReportsRepository extends BaseRepository<any> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.posApiUrl + '/' + 'reports', token, cache)
    }

    async InvoicesPersonsPending(from: Date, to: Date) {
        const { json, statusCode, message } = await this.request.get(
            this.config.posApiUrl +
                '/reports/invoices/persons/pending?from=' +
                from +
                '&to=' +
                to +
                '&token=' +
                this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async InvoicesPersonsAll(from: Date, to: Date) {
        const { json, statusCode, message } = await this.request.get(
            this.config.posApiUrl +
                '/reports/invoices/persons/all?from=' +
                from +
                '&to=' +
                to +
                '&token=' +
                this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
